module.exports = "<div>\n\n<p align= justify style=\"padding: 20px\">{{ text }}</p>\n\n</div>\n\n"